import { ReactElement } from "react";

import { useTranslation } from "@/v2/hooks/useTranslation";

import { FreeSpinsRetrievalPanel } from "./FreeSpinsRetrievalPanel";

/** The retrieval could not run: its message, or a generic one. */
export const FreeSpinsRetrievalError = (props: FreeSpinsRetrievalErrorProps): ReactElement => {
  const { message } = props;
  const { t } = useTranslation();

  return (
    <FreeSpinsRetrievalPanel type="error">
      {t("free-spin.fs-retrieval-modal.error", {
        message: message ?? t("free-spin.fs-retrieval-modal.unexpected-error"),
      })}
    </FreeSpinsRetrievalPanel>
  );
};

interface FreeSpinsRetrievalErrorProps {
  message: string | null;
}
